<template>
  <div class="intelligentMotor-page EEEManagement-page">
    <!-- 能效管理 -->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="caseDetails-banner-container">
      <div class="case-info-container">
        <p class="case-title">能效管理</p>
        <p class="case-describe">面向工业企业，生产车间，工业园区智能制造和低碳城市，提供能源物联网（Energy IoT）、能源管理系统（EMS）和能源大数据服务。</p>
        <!-- <a href="javascript:;" class="case-see-more-btn">查看更多</a> -->
      </div>
    </div>
    <div class="caseDetails-all-content-container">
      <div class="case-introduce-item-container Fun1">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <div class="text-img-item-container">
              <div class="text-container">
                <p class="interface-title">01</p>
                <p class="interface-describe">通过能耗数据采集，分析用能趋势</p>
              </div>
              <div class="img-container">
                <img src="../../assets/img/caseDetails/EEEManagement/default_img1.png" alt="" class="interface-img">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container Fun2">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <div class="text-img-item-container">
              <div class="text-container">
                <p class="interface-title whiteText">02</p>
                <p class="interface-describe whiteText">数据监测和远程监控，设备检修与维护管理</p>
              </div>
              <div class="img-container">
                <img src="../../assets/img/caseDetails/EEEManagement/default_img2.png" alt="" class="interface-img">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container Fun3">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <div class="text-img-item-container">
              <div class="text-container">
                <p class="interface-title">03</p>
                <p class="interface-describe">能秏管理报表，可在线查询历史数据</p>
              </div>
              <div class="img-container">
                <img src="../../assets/img/caseDetails/EEEManagement/default_img3.png" alt="" class="interface-img">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'EEEManagement',
  components:{
    Header,
    Nav,
    Foot
  },
}
</script>
<style lang="scss">
  
</style>